import { render } from "./CardThirtyTwo.vue?vue&type=template&id=06b1c96a"
import script from "./CardThirtyTwo.vue?vue&type=script&lang=js"
export * from "./CardThirtyTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__